import Index from '../views/Graphic/Index'

let routes = {
    path: '/graphics',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/graphics',
            name: 'list-graphics',
            component: Index,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Gráfico de fechamento de cards da semana',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
